import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-page-header-breadcrumb',
  templateUrl: './page-header-breadcrumb.component.html',
  styleUrls: ['./page-header-breadcrumb.component.scss'],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class PageHeaderBreadcrumbComponent implements OnInit {
  @Input() pageTitle: string = '';
  @Input() breadcrumbList: any[] = [];
  @Input() pageSubtitle: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
